import { deepEqual } from "@pack-it-up/shared";
const isPacking = (it) => "quantity" in it;
// Capture the content fields of an item/todo. Optional keys are omitted when
// absent (never set to `undefined`) so snapshots compare cleanly under
// exactOptionalPropertyTypes.
export const snapshotOf = (it) => {
    const snap = { name: it.name, assignment: it.assignment };
    if (it.description !== undefined)
        snap.description = it.description;
    if (it.notes !== undefined)
        snap.notes = it.notes;
    if (it.tags !== undefined)
        snap.tags = it.tags;
    if (isPacking(it)) {
        snap.quantity = it.quantity;
    }
    else if (it.relativeDueOffset !== undefined) {
        snap.relativeDueOffset = it.relativeDueOffset;
    }
    return snap;
};
// Content equality against a snapshot — the ground-truth behind modifiedSinceImport
// and the reset affordance. Order/placement/completion are not content.
export const contentEquals = (current, snapshot) => deepEqual(current, snapshot);
// Drop one template's claim on a row: remove its source and its entry in the flat
// `templateIds` mirror, leaving content and every other source untouched (Doc 07 §5,
// Doc 13 §6). Shared by template delete and sync-back.
export const detach = (provenance, templateIds, templateId) => ({
    provenance: {
        ...provenance,
        templateSources: provenance.templateSources.filter((s) => s.templateId !== templateId),
    },
    templateIds: (templateIds ?? []).filter((id) => id !== templateId),
});
// Re-derive the cached modified flag; edit use-cases call this to keep it honest.
// An item with no provenance has nothing to be modified against ⇒ false.
export const deriveModified = (it) => {
    if (it.provenance == null)
        return false;
    return !contentEquals(snapshotOf(it), it.provenance.importedSnapshot);
};
//# sourceMappingURL=provenance.js.map